/** Elapsed time between two ISO timestamps as "N seconds" / "Nm Ns"; null if unparseable. */
export const formatThinkingDuration = (startedAt: string | null, endedAt: string): string | null => {
  if (!startedAt) return null;
  const start = new Date(startedAt).getTime();
  const end = new Date(endedAt).getTime();
  if (Number.isNaN(start) || Number.isNaN(end) || end < start) return null;

  const seconds = Math.max(1, Math.round((end - start) / 1000));
  if (seconds === 0) return null;
  if (seconds < 60) return `${seconds}s`;

  const minutes = Math.floor(seconds / 60);
  const remainder = seconds % 60;
  if (remainder === 0) return `${minutes}m`;
  return `${minutes}m ${remainder}s`;
};
